import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { FormItem } from '~/shadcn/ui/form/form'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { CurrencyInput } from '~/@mid_ui-form/currency-input/CurrencyInput'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { stringNumberSchema } from '~/@pages_onboarding/investor-analysis/_analysis-form/schemas'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step1Schema = z.object({ annualNetIncome: stringNumberSchema })
export type Step1Data = z.infer<typeof step1Schema>

export function Step1() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step1Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => {
        return (
          <>
            <StepTitle>
              {unsophisticatedQuestions.annualNetIncome.question.label}
            </StepTitle>
            <Controller
              name="annualNetIncome"
              control={control}
              render={({ fieldState, field }) => (
                <FormItem className="w-full">
                  <CurrencyInput
                    autoFocus
                    aria-invalid={!!fieldState?.error}
                    labelText="Ročný čistý príjem"
                    value={field.value}
                    onChangeValue={field.onChange}
                    className="lg:w-[240px]"
                  />
                </FormItem>
              )}
            />
            <div className="flex items-center gap-2">
              <TextTooltip
                text={
                  'Čistý ročný príjem je hrubý príjem mínus všetky odpočty a dane.'
                }
                triggerContent="Aká je výška vášho ročného čistého príjmu?"
              />
            </div>
          </>
        )
      }}
    />
  )
}
